require('es6-promise').polyfill()

import _ from 'lodash'
import axios from 'axios'

const API_KEY = 'fc9fb92aa0f29e6d43f570f02222e1a1'
const URL = 'https://ws.audioscrobbler.com/2.0/'
const setActive = (v) => {
  v.active = false
  return v
}

export default {
  search (state, payload) {
    axios.get(`${URL}?${state.searchType}=${payload.tearm}`, {
      params: {
        method: `${state.searchType}.search`,
        page: state.nextLink,
        api_key: API_KEY,
        limit: 20,
        format: 'json'
      }
    })
      .then((response) => {
        let data = response.data
        let results = data.results[`${state.searchType}matches`][state.searchType]
        let hasMoreResults = data.results['opensearch:totalResults'] - data.results['opensearch:itemsPerPage'] - data.results['opensearch:startIndex']
        _.forEach(results, setActive)

        if (payload.type !== 'search') {
          state.offset = data.results['opensearch:startIndex']
          state.searchResults = state.searchResults.concat(results)
          state.nextLink = hasMoreResults > 0 ? ++state.nextLink : false
        } else {
          state.offset = 0
          state.searchResults = results
          state.nextLink = hasMoreResults > 0 ? 2 : false
        }

        state.total = state.searchResults.length
        state.searchTearm = payload.tearm
        state.noResults = state.total <= 0
      }, (response) => {
        this.error = response.data
      })
  },
  searchType (state, payload) {
    state.searchType = payload.val
    state.searchResults = []
    state.nextLink = 1
    state.total = null
  },
  trackList (state, payload) {
    axios.get(`${URL}`, {
      params: {
        method: 'album.getinfo',
        api_key: API_KEY,
        mbid: payload.mbid,
        format: 'json'
      }
    })
    .then((response) => {
      let trackList = response.data.album.tracks.track

      state.tracks = trackList
    }, (response) => {
      this.error = response.data
    })
  },
  artistBio (state, payload) {
    state.bioContent = ''
    state.bio = []
    state.bioImg = ''
    state.similarArtist = []

    axios.get(`${URL}`, {
      params: {
        method: 'artist.getinfo',
        api_key: API_KEY,
        artist: payload.name,
        autocorrect: 1,
        format: 'json'
      }
    })
    .then((response) => {
      let bio = response.data.artist
      let bioContent = bio.bio.content.replace(/(\r\n|\n|\r)/gm, '<br />')
      let bioImg = bio.image[3]['#text']
      let similarArtist = bio.similar.artist
      state.bioContent = bioContent
      state.bio = bio
      state.bioImg = bioImg
      state.similarArtist = similarArtist
    }, (response) => {
      this.error = response.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/mutations/index.js